export default __webpack_public_path__ + "static/media/josera.fb0a3237.jpg";